import { render } from "./EditarInvitado.vue?vue&type=template&id=d6c0c212&scoped=true"
import script from "./EditarInvitado.vue?vue&type=script&lang=js"
export * from "./EditarInvitado.vue?vue&type=script&lang=js"

import "./EditarInvitado.vue?vue&type=style&index=0&id=d6c0c212&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c0c212"]])

export default __exports__